module.exports = __webpack_public_path__ + "img/img.71c30265.png";